  import { CustomField } from "@/backend/models/customFields/customField";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { I18n } from "@/i18n/I18n";
import { ParameterInputType } from "@/types/parameterTypes";
import { Parameter } from "@/backend/models/parameter";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { CustomFieldInput } from "../customFIelds/CustomFieldInput";
import { DeleteParameterFieldButton } from "./DeleteParameterFieldButton";

export function ListEdit(props: { parameter: Parameter, disabled?: boolean }) {
  const { parameter, disabled } = props;
  const updateCustomField = useParameterStore(state => state.updateCustomField);
  const selectedField = parameter.fields.find((field) => field.isSelected);
  const isChoice = parameter.isChoice();

  const selectValue = (field: CustomField, isSelected: boolean) => {
    if (selectedField && parameter.inputType === ParameterInputType.SINGLE_CHOICE) {
      void updateCustomField({ ...selectedField, isSelected: false });
    }
    void updateCustomField({ ...field, isSelected });
  };

  return (
    <div className='d-flex flex-column gap-1'>
      {parameter.fields.map(field => (
        <div key={field.id} className='d-flex'>
          {isChoice && (
            <div
              className='align-middle'
              onClick={() => selectValue(field, !field.isSelected)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  selectValue(field, !field.isSelected);
                }
              }}
            >
              <Form.Check
                type={parameter.inputType === ParameterInputType.MULTIPLE_CHOICE ? 'checkbox' : 'radio'}
                checked={field.isSelected}
                aria-label={I18n.get('selectValue', { value: field.getLabel() })}
                onChange={() => {}}
              />
            </div>
          )}
          <div className='d-flex'>
            {isChoice && <ChoiceLabelInput field={field} disabled={disabled} />}
            <CustomFieldInput customField={field} isEditView />
            {!disabled && <DeleteParameterFieldButton field={field} fieldCount={parameter.fields.length} />}
          </div>
        </div>
      ))}
      {isChoice && <div className='text-sm-hint'>{I18n.get('choiceLabelHint')}</div>}
    </div>
  );
}

// The label operators see for a choice. When it is blank the value is shown instead,
// so a `10x` probe setting can be offered for an underlying value of `0.1`.
function ChoiceLabelInput(props: { field: CustomField, disabled?: boolean }) {
  const { field, disabled } = props;
  const updateCustomField = useParameterStore(state => state.updateCustomField);
  const [label, setLabel] = useState(field.title);

  useEffect(() => {
    setLabel(field.title);
  }, [field.title]);

  const saveLabel = () => {
    if (label === field.title) return;
    void updateCustomField({ ...field, title: label });
  };

  return (
    <Form.Control
      size='sm'
      className='me-1 align-self-start'
      aria-label={I18n.get('enterField', { field: I18n.get('label') })}
      placeholder={I18n.get('label')}
      value={label}
      onChange={(event) => setLabel(event.target.value)}
      onBlur={saveLabel}
      disabled={disabled}
      style={{ minWidth: '150px', maxWidth: '150px' }}
    />
  );
}
